import {
  LogLevel,
  PublicClientApplication,
  type Configuration,
} from '@azure/msal-browser'

export interface EcrmMsalPcaOptions {
  clientId: string
  authorityUrl: string
  /** Match prior admin-desk behavior: verbose MSAL browser logging. */
  verboseMsalLogging?: boolean
}

export function createMsalPublicClientApplication(
  options: EcrmMsalPcaOptions
): PublicClientApplication {
  const configuration: Configuration = {
    auth: {
      clientId: options.clientId,
      authority: options.authorityUrl,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      allowRedirectInIframe: false,
      ...(options.verboseMsalLogging
        ? {
            loggerOptions: {
              loggerCallback: (_level, message) =>
                console.log('[MSAL]', message),
              logLevel: LogLevel.Verbose,
            },
          }
        : {}),
    },
  }
  return new PublicClientApplication(configuration)
}

/** Default scopes for interactive + silent token requests (matches agent-desk `getMsalScopes`). */
export function getMsalScopes(apiResourceScope: string): string[] {
  return ['openid', 'profile', 'email', apiResourceScope]
}

/**
 * Signs the user out of this application only: clears MSAL token cache in the browser.
 * Does not call Entra `end_session` — the user may remain signed in to Microsoft SSO for other apps.
 */
export async function clearMsalAppSessionOnly(
  instance: PublicClientApplication
): Promise<void> {
  await instance.initialize()
  await instance.clearCache()
  instance.setActiveAccount(null)
}
